import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { MultipleEntityAutoQuery, SingleEntityAutoQuery } from '../../generic/EntityAutoQuery';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const EntityAutoQueryWidget = (props) => {
    const [singleEntity, setSingleEntity] = useState(null);
    const [multipleEntities, setMultipleEntities] = useState([]);
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "SingleEntityAutoQuery" }), _jsx(Stack, { direction: "row", children: props.contextCustomer && (_jsx(SingleEntityAutoQuery, { contextObject: props.contextCustomer, entityType: 'User', currentEntity: singleEntity, setCurrentEntity: setSingleEntity, label: "Select a user", fullWidth: false })) }), _jsx(Typography, { variant: "h5", children: "MultipleEntityAutoQuery" }), _jsx(Stack, { direction: "row", children: props.contextCustomer && (_jsx(MultipleEntityAutoQuery, { contextObject: props.contextCustomer, entityType: 'User', currentEntities: multipleEntities, setCurrentEntities: setMultipleEntities, label: "Select several users", fullWidth: false })) })] })), [props.contextCustomer, singleEntity, multipleEntities]);
    return {
        name: 'EntityAutoQuery',
        category: 'generic',
        component,
    };
};
